module.exports = __webpack_public_path__ + "img/smw-library10.8858b643.jpg";